// Frequently asked questions. grouped, used on /faq and home.

export const FAQ_GROUPS = [
  {
    title: "Buying a home",
    items: [
      {
        q: "How much money do I need to buy a home in DFW?",
        a: "It depends on the loan type. FHA loans start at 3.5% down, conventional loans can start at 3-5% down, and VA/USDA loans can be 0% down. You'll also need closing costs of about 2-5% of the purchase price. On a $350K home, that's roughly $10,500-$28,000 cash to close. Your licensed lender can give you exact numbers.",
      },
      {
        q: "Should I get preapproved before looking at homes?",
        a: "Yes. preapproval shows sellers you're serious and tells you exactly what you can afford. Without it, most sellers in DFW won't even consider your offer. Preapproval is a hard credit pull with verified docs (W-2s, paystubs, bank statements).",
      },
      {
        q: "How long does it take to buy a home?",
        a: "From offer to closing is typically 30-45 days. House-hunting before that can take days to months depending on inventory and your criteria. Once you're under contract, the 8-stage process (inspection → appraisal → underwriting → clear to close → closing) follows a predictable timeline.",
      },
      {
        q: "Do I have to pay my buyer's agent?",
        a: "Buyer compensation rules changed in August 2024. We'll walk you through your options in our first consultation. many sellers still offer to compensate buyer agents, but it's negotiated up front now.",
      },
    ],
  },
  {
    title: "Selling your home",
    items: [
      {
        q: "How do I find out what my home is worth?",
        a: "Skip the Zestimate. it's an algorithm, not a market analysis. Torey provides a free, no-obligation Comparative Market Analysis (CMA) within 24 hours, using actual recent comparable sales within a 5-mile radius.",
      },
      {
        q: "How long will my home take to sell?",
        a: "Most well-priced DFW homes we list go under contract within 7-30 days. The full process. contract to close. adds another 30-45 days. Total: typically 45-75 days from listing to keys.",
      },
      {
        q: "What does it cost to sell?",
        a: "Seller costs typically include agent commissions (negotiated up front), title fees, transfer fees, and any agreed concessions. We give you a net-proceeds estimate before you list so there are no surprises.",
      },
    ],
  },
  {
    title: "Lending & rates",
    items: [
      {
        q: "Should I wait for rates to drop before buying?",
        a: "It's a trade-off, not a slam-dunk. Lower rates often bring more buyer competition (higher prices, more bidding wars). The right call depends on your timing, current rent, and personal readiness. A licensed lender can compare scenarios with your real numbers.",
      },
      {
        q: "What credit score do I need?",
        a: "FHA loans generally accept 580+, conventional 620+, and the best rates start around 740+. Different lenders have different overlays. get pre-qualified to see your actual options.",
      },
      {
        q: "Can Jason quote me an interest rate?",
        a: "No. and any agent or online tool that does is breaking lending regulations. Rates change daily and depend on your credit, loan type, and lock period. Jason can explain how rates work and connect you with a licensed lender for actual numbers.",
      },
    ],
  },
  {
    title: "The Irving Experience",
    items: [
      {
        q: "Who is Jason?",
        a: "Jason is the Irving Real Estate Group concierge. He answers questions about buying, selling, mortgages, and your active transaction 24/7. and hands off to Torey when you're ready for a real conversation.",
      },
      {
        q: "Is the data on this site live?",
        a: "Yes. once NTREIS Trestle is wired in, all listings come straight from the Texas MLS and update in real time. Demo listings are clearly marked while the integration finalizes.",
      },
      {
        q: "Will Torey call me 100 times after I submit a form?",
        a: "No. We respect your timeline. You set the pace. Torey reaches out when you say you're ready.",
      },
    ],
  },
];
